import Layout from "../components/layout";
import * as React from "react";
import {graphql} from "gatsby";
import {GatsbyImage, getImage} from "gatsby-plugin-image";
import {FaExternalLinkAlt} from "react-icons/fa";

const HotelsPage = ({ data }) => {

  const hotels = [
    {
      name: 'Hotel Anno 1216',
      href: 'https://www.hotelanno1216.de/',
      description: 'Alfstraße 38, 23552 Lübeck',
      image: getImage(data.hotelAnno1216)
    },
    {
      name: 'Ibis Lübeck Süd',
      href: 'http://ibis-budget-city-sued.lubeck-hotels.com/de/',
      description: 'Berliner Str. 1-1A, 23560 Lübeck',
      image: getImage(data.ibis)
    },
    {
      name: 'the niu Rig Hotel',
      href: 'https://the.niu.de/hotels/deutschland/luebeck/the-niu-rig',
      description: 'Am Bahnhof 17-19, 23558 Lübeck',
      image: getImage(data.theNiuRig)
    }
  ]

  return (
    <Layout title={'Hotels'}>
      <section className="p-8">
        <h1>
          Hotels
        </h1>
        <p className="text-xl mb-8">
          Für Übernachtungsmöglichkeiten haben wir euch hier 3 Hotelvorschläge in der Umgebung rausgesucht. Natürlich gibt es in Lübeck noch viele weitere Alternativen.
        </p>
        { hotels.map((hotel, index) => (
          <a key={`hotel-${index}`} href={hotel.href} target='_blank' rel='noreferrer'>
            <div className="flex flex-col sm:flex-row items-center gap-4 my-6">
              {hotel.image && <GatsbyImage image={hotel.image} alt={hotel.name}/>}
              <div className={"text-center sm:text-left"}>
                <h2 className="mt-0 font-bold leading-6 flex flex-row justify-center sm:justify-start items-center">
                  {hotel.name}
                  <span className={"ml-4 text-xl"}><FaExternalLinkAlt/></span>
                </h2>
                <p className="my-1 text-xl">{hotel.description}</p>
              </div>
            </div>
          </a>
        ))}
      </section>
    </Layout>
  )
}

export const query = graphql`
  query {
    hotelAnno1216: file(relativePath: { eq: "hotel-anno-1216.jpeg" }) {
      childImageSharp {
        gatsbyImageData(
          width: 200
          placeholder: BLURRED
        )
      }
    }
    theNiuRig: file(relativePath: { eq: "the-niu-rig.jpeg" }) {
      childImageSharp {
        gatsbyImageData(
          width: 200
          placeholder: BLURRED
        )
      }
    }
    ibis: file(relativePath: { eq: "ibis-lubeck-sud.jpeg" }) {
      childImageSharp {
        gatsbyImageData(
          width: 200
          placeholder: BLURRED
        )
      }
    }
  }
`

export default HotelsPage
